var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18.0885L13.8595 14.8077C13.0583 14.2692 12.2036 13.8606 11.2952 13.5818C10.3869 13.3029 9.45517 13.1635 8.5 13.1635C7.54483 13.1635 6.61058 13.3045 5.69725 13.5865C4.78375 13.8687 3.918 14.2706 3.1 14.7922L8.5 18.0885ZM8.5 10.6635C9.4025 10.6635 10.1698 10.3475 10.802 9.7155C11.434 9.08333 11.75 8.316 11.75 7.4135C11.75 6.511 11.434 5.74367 10.802 5.1115C10.1698 4.4795 9.4025 4.1635 8.5 4.1635C7.5975 4.1635 6.83017 4.4795 6.198 5.1115C5.566 5.74367 5.25 6.511 5.25 7.4135C5.25 8.316 5.566 9.08333 6.198 9.7155C6.83017 10.3475 7.5975 10.6635 8.5 10.6635ZM8.5 19.827L0 14.6348V5.19225L8.5 0L17 5.19225V14.6348L8.5 19.827Z",
    fill: "#3D4AF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIc);
export default __webpack_public_path__ + "static/media/customer-ic.7fbb981faf2a6f36f83f8742fff7f3d1.svg";
export { ForwardRef as ReactComponent };